var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 322,
    viewBox: "0 0 322 322",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2101 9.27417C41.9054 -3.02759 21.9679 -3.02759 9.66323 9.27417C-2.64146 21.5754 -2.64146 41.5203 9.66323 53.822L116.374 160.531L9.34292 266.916C-3.00083 279.181 -3.05552 299.125 9.20229 311.464C21.4679 323.802 41.4132 323.863 53.757 311.599L160.921 205.079L267.765 311.922C280.062 324.224 300.007 324.224 312.312 311.922C324.616 299.621 324.616 279.676 312.312 267.375L205.601 160.666L312.632 54.2805C324.976 42.0159 325.03 22.0715 312.765 9.73267C300.507 -2.60571 280.562 -2.66626 268.218 9.5979L161.054 116.117L54.2101 9.27417Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.83a981705825ab8bcf041490609e208b.svg";
export { ForwardRef as ReactComponent };